import React from 'react';
import Placeholder from 'components/Placeholder';

import styles from './styles.module.scss';

const CBDescription = (props) => {
  const {isLoading, data} = props;
  const {certification_bodies_desc} = data;

  return (
    <section className={styles['cb-description']}>
      <h3 className={styles['section__title']}>Description</h3>
      <Placeholder
        tag="p"
        rows={5}
        className="text-secondary my-4"
        isReady={!isLoading}
        data={certification_bodies_desc}
      >
        {certification_bodies_desc}
      </Placeholder>
    </section>
  );
};

export default CBDescription;
